/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onbilgi_S8_P1Inputs */

const tr_onbilgi_s8_p1 = /** @type {(inputs: Onbilgi_S8_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cayma hakkı, aşağıdaki yolla kullanılır:`)
};

const en_onbilgi_s8_p1 = /** @type {(inputs: Onbilgi_S8_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The right of withdrawal is exercised as follows:`)
};

const de_onbilgi_s8_p1 = /** @type {(inputs: Onbilgi_S8_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Das Widerrufsrecht wird auf folgendem Weg ausgeübt:`)
};

const ru_onbilgi_s8_p1 = /** @type {(inputs: Onbilgi_S8_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Право на отказ от договора реализуется следующим образом:`)
};

/**
* | output |
* | --- |
* | "The right of withdrawal is exercised as follows:" |
*
* @param {Onbilgi_S8_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const onbilgi_s8_p1 = /** @type {((inputs?: Onbilgi_S8_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onbilgi_S8_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onbilgi_s8_p1(inputs)
	if (locale === "de") return de_onbilgi_s8_p1(inputs)
	if (locale === "ru") return ru_onbilgi_s8_p1(inputs)
	return tr_onbilgi_s8_p1(inputs)
});